const numberFormatter = (number: number | string) => {
  const value = number.toLocaleString("pt-BR");

  return value;
};

export default numberFormatter;
